/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicantTableColumnOption } from '../models/ApplicantTableColumnOption';
import type { JobDetailedResponse } from '../models/JobDetailedResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApiSelfServeV1Service {

    /**
     * show
     * Returns Job
     * @param id Job#external_id
     * @returns JobDetailedResponse success
     * @throws ApiError
     */
    public static getApiSelfServeV1Jobs(
        id: string,
    ): CancelablePromise<JobDetailedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api_self_serve/v1/jobs/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * options
     * Returns the columns available for the current account and user to select in the openings table
     * @returns ApplicantTableColumnOption success
     * @throws ApiError
     */
    public static getApiSelfServeV1OpeningsTableColumnsOptions(): CancelablePromise<Array<ApplicantTableColumnOption>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api_self_serve/v1/openings_table_columns/options',
            errors: {
                403: `forbidden when feature flag is disabled`,
            },
        });
    }

    /**
     * create
     * Creates a new column config for the current user, and returns the resulting column selection
     * @param requestBody
     * @returns ApplicantTableColumnOption success
     * @throws ApiError
     */
    public static postApiSelfServeV1OpeningsTableColumns(
        requestBody?: {
            columns: Array<{
                column_name: string;
                position: number;
            }>;
        },
    ): CancelablePromise<Array<ApplicantTableColumnOption>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api_self_serve/v1/openings_table_columns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `forbidden when feature flag is disabled`,
                422: `unknown column name`,
            },
        });
    }

}